import PropTypes from "prop-types";
import { memo } from "react";

// Sections
import CallActivityPerformanceComponent from "@PayPlans/components/Commons/CallActivityPerformance";
import LongevityComponent from "@PayPlans/components/Commons/Longevity";
import CustomerSatisfactionComponent from "@PayPlans/components/Commons/CustomerSatisfaction";
import ExcellenceMakesComponent from "@PayPlans/components/OEMs/ExcellenceMakes";
import OperatingCostsComponent from "@PayPlans/components/Commons/OperatingCosts";

// Customs
import GrossDepartmentalComponent from "@PayPlans/components/Defaults/Managers/Departmental/GrossDepartmental";

function CallActivityPerformanceSection(props) {
	const { sectionId = "callActivityPerformance", performance = null } = props;
	return <CallActivityPerformanceComponent {...props} sectionId={sectionId} performance={performance} />;
}
CallActivityPerformanceSection.propTypes = {
	sectionId: PropTypes.string,
	performance: PropTypes.object,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

function CustomerSatisfactionSection(props) {
	const { sectionId = "customerSatisfaction", excludesMakes = ["Cadillac"], useOnlyStoreMetrics = true } = props;
	return (
		<CustomerSatisfactionComponent
			{...props}
			sectionId={sectionId}
			excludesMakes={excludesMakes}
			useOnlyStoreMetrics={useOnlyStoreMetrics}
		/>
	);
}
CustomerSatisfactionSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		makeMetrics: PropTypes.array,
		weighting: PropTypes.shape({
			weightingType: PropTypes.string,
			customWeights: PropTypes.array,
		}),
	}),
	excludesMakes: PropTypes.array,
	errors: PropTypes.array,
	isService: PropTypes.bool,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	useOnlyIndividualMetrics: PropTypes.bool,
	useOnlyStoreMetrics: PropTypes.bool,
	onActionUpdate: PropTypes.func,
};

function LongevitySection(props) {
	const {
		sectionId = "longevity",
		constraints = {
			noDollarAmount: true,
		},
	} = props;
	return <LongevityComponent {...props} sectionId={sectionId} constraints={constraints} />;
}
LongevitySection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.array,
	constraints: PropTypes.object,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

function GrossDepartmentalSection(props) {
	const {
		sectionId = "grossDepartmental",
		content = {
			makes: [],
			combineOEMs: false,
			isGuaranteedDraw: false,
		},
		locationOEMs = [],
		excludesOEMs = [],
	} = props;

	return (
		<GrossDepartmentalComponent
			{...props}
			sectionId={sectionId}
			content={content}
			locationOEMs={locationOEMs}
			excludesOEMs={excludesOEMs}
		/>
	);
}
GrossDepartmentalSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		makes: PropTypes.array,
		combineOEMs: PropTypes.bool,
		isGuaranteedDraw: PropTypes.bool,
	}),
	locationOEMs: PropTypes.array,
	excludesOEMs: PropTypes.array,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

function EBESection(props) {
	const { sectionId = "ebe", reference = "EBE", department = "SERVICE" } = props;
	return <ExcellenceMakesComponent {...props} sectionId={sectionId} reference={reference} department={department} />;
}
EBESection.propTypes = {
	sectionId: PropTypes.string,
	reference: PropTypes.string,
	department: PropTypes.string,
	content: PropTypes.shape({
		makeMetrics: PropTypes.array,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

function PASESection(props) {
	const { sectionId = "pase", reference = "PASE", department = "SERVICE" } = props;
	return <ExcellenceMakesComponent {...props} sectionId={sectionId} reference={reference} department={department} />;
}
PASESection.propTypes = {
	sectionId: PropTypes.string,
	reference: PropTypes.string,
	department: PropTypes.string,
	content: PropTypes.shape({
		makeMetrics: PropTypes.array,
	}),
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};
function OperatingCostsSection(props) {
	const { sectionId = "operatingCosts" } = props;
	return <OperatingCostsComponent {...props} sectionId={sectionId} />;
}
OperatingCostsSection.propTypes = {
	sectionId: PropTypes.string,
	content: PropTypes.shape({
		makes: PropTypes.array,
		combineOEMs: PropTypes.bool,
	}),
	oems: PropTypes.array,
	loading: PropTypes.bool,
	readOnly: PropTypes.bool,
	onActionUpdate: PropTypes.func,
	useSectionsErrors: PropTypes.func,
};

const CallActivityPerformance = memo(CallActivityPerformanceSection);
const CustomerSatisfaction = memo(CustomerSatisfactionSection);
const EBEBonus = memo(EBESection);
const Longevity = memo(LongevitySection);
const GrossDepartmental = memo(GrossDepartmentalSection);
const PASEBonus = memo(PASESection);
const OperatingCosts = memo(OperatingCostsSection);

export { CallActivityPerformance, CustomerSatisfaction, EBEBonus, Longevity, GrossDepartmental, PASEBonus, OperatingCosts };
